export default "/content/plugin-channel-alarms/59c81859050dd06045f168802f2c1b5a.wav";